export default __webpack_public_path__ + "static/media/logo.073b9921.svg";